import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { volumes, lessonGroups } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-271" data-mp="cp0zcd90b28x">
      <div className="max-w-6xl mx-auto" data-id="element-272" data-mp="cnpv6cbnfsha">
        <div className="text-center mb-16" data-id="element-273" data-mp="7po537ft2swb">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-274" data-mp="7pxrym5k0jxs">
            The Teaching Library
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-275" data-mp="3c3mge6p356ub">
            7 complete volumes of art lessons ready to teach
          </h2>
          <p className="text-xl text-terracotta-dark" data-id="element-276" data-mp="3pwc7gpjh11ya">
            Organized by artistic focus · All levels covered · Nothing to build
            from zero
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-277" data-mp="2xd5iuyfkn12p">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper rounded-2xl border ${volume.featured ? 'border-terracotta shadow-[0_10px_30px_-18px_rgba(138,74,43,0.45)]' : 'border-warmgray'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-278" data-mp="2sf40kfpyz5sa" data-mpi={index}>
              {volume.featured && volume.badge && <div className="absolute top-6 right-[-35px] bg-terracotta-deep text-paper font-bold text-xs py-1 px-10 rotate-45 shadow-sm" data-id="element-279" data-mp="24gxe6t9t3kgb">
                  {volume.badge}
                </div>}

              <div className="mb-6 pr-16" data-id="element-280" data-mp="3fujbj1ptkscx">
                <div className="text-terracotta font-bold text-sm uppercase tracking-wider" data-id="element-281" data-mp="3fxnlkfpyuibi">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-charcoal" data-id="element-282" data-mp="1bsj0mhjn8tbq">
                  {volume.title}
                </h3>
              </div>

              <p className="text-charcoal font-medium mb-6 italic border-l-2 border-terracotta/50 pl-4" data-id="element-283" data-mp="1ksefawcer6gi">
                {volume.subtitle}
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-284" data-mp="x3d26vsmr74w">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-285" data-mp="t32yxqw82utq">
                    <CheckCircle2 size={18} className="text-terracotta shrink-0 mt-0.5" aria-hidden="true" data-id="element-286" data-mp="16tetrxk6z7ok" />
                    <span className="text-charcoal-soft text-sm" data-id="element-287" data-mp="ebambmntbuvp">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-sand border border-warmgray rounded-xl p-4 mt-auto" data-id="element-288" data-mp="9b6d8hp8i2fi">
                <span className="text-terracotta-deep font-bold block mb-1" data-id="element-289" data-mp="2kzba26u0dzt9">
                  Result:
                </span>
                <p className="text-charcoal-soft text-sm" data-id="element-290" data-mp="2bzwjl7dudp8r">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-12 bg-sand border border-warmgray rounded-2xl p-8" data-id="element-291" data-mp="2gzsn75imnens">
          <div className="flex items-center gap-3 mb-8" data-id="element-292" data-mp="2znnxgff16ac5">
            <BookOpen size={20} className="text-terracotta" aria-hidden="true" data-id="element-293" data-mp="1jazb1vzfn6t7" />
            <h3 className="text-lg font-bold text-charcoal" data-id="element-294" data-mp="1oa24ej61volc">
              The 150 Ready-to-Teach Lessons, organized
            </h3>
          </div>
          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-5" data-id="element-295" data-mp="23ljte6dld3lz">
            {lessonGroups.map(group => <li key={group.title} className="border-l-2 border-terracotta/40 pl-4" data-id="element-296" data-mp="1yryy4m3dunqh">
                <p className="font-bold text-charcoal" data-id="element-297" data-mp="1psu2bnj7h8i0">{group.title}</p>
                <p className="text-sm text-charcoal-muted" data-id="element-298" data-mp="1pqhe4smuu1wi">{group.detail}</p>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}